import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { MembershipPauseResponse, PauseRequest, ResumeRequest } from '../types/domain';

export function membershipEndpoints(http: HttpClient) {
  return {
    pause: (body: PauseRequest) => http.post<ApiEnvelope<MembershipPauseResponse>>('/v1/membership/pause', body).then(unwrap),
    resume: (clientPlanId: string, body: ResumeRequest = {}) => http.post<ApiEnvelope<MembershipPauseResponse>>(`/v1/membership/${clientPlanId}/resume`, body).then(unwrap),
    pauses: (clientPlanId: string) => http.get<ApiEnvelope<MembershipPauseResponse[]>>(`/v1/membership/${clientPlanId}/pauses`).then(unwrap),
  };
}
export type MembershipEndpoints = ReturnType<typeof membershipEndpoints>;
